(() => {
  class PhotoReviews extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.pageSize = Math.max(1, Math.min(50, Number(this.dataset.pageSize) || 20)); this.limit = this.pageSize;
      this.filter = this.querySelector('[data-review-filter]');
      this.detail = this.querySelector('[data-review-detail]');
      this.writer = this.querySelector('[data-review-writer]');
      this.querySelector('[data-write-review]')?.addEventListener('click', e => this.open(this.writer, e.currentTarget), options);
      this.querySelectorAll('[data-review-open]').forEach(button => button.addEventListener('click', () => this.showReview(button.closest('[data-review-card]'), button), options));
      this.filter?.addEventListener('change', () => { this.limit = this.pageSize; this.update(); }, options);
      this.querySelector('[data-review-more]')?.addEventListener('click', () => { this.limit += this.pageSize; this.update(); }, options);
      this.querySelectorAll('.review-rating-options input').forEach(input => input.addEventListener('change', () => {
        input.closest('.review-rating-options').querySelectorAll('label').forEach(label => label.toggleAttribute('data-selected', Number(label.querySelector('input').value) <= Number(input.value)));
      }, options));
      this.querySelector('[data-review-photo]')?.addEventListener('change', () => this.validatePhoto(), options);
      this.querySelector('[data-demo-review-form]')?.addEventListener('submit', event => this.preview(event), options);
      this.querySelector('[data-review-clear]')?.addEventListener('click', () => this.clearPreview(), options);
      this.querySelector('[data-contact-review-form]')?.addEventListener('submit', event => {
        if (this.submitting) { event.preventDefault(); return; }
        // The browser submits the native Shopify form. Never manufacture success.
        this.submitting = true;
        event.currentTarget.querySelector('[type=submit]').disabled = true;
      }, options);
      window.addEventListener('pageshow', () => {
        this.submitting = false;
        const submit = this.querySelector('[data-contact-review-form] [type=submit]'); if (submit) submit.disabled = false;
      }, options);
      this.update();
      if (this.querySelector('[data-review-server-result]')) this.open(this.writer, this.querySelector('[data-write-review]'));
    }
    open(dialog, opener) {
      if (!dialog) return;
      window.PortraitStore.openDialog(dialog, opener);
    }
    update() {
      const rating = Number(this.filter?.value || 0);
      const matching = this.cards.filter(card => !rating || Number(card.dataset.rating) === rating);
      this.cards.forEach(card => { card.hidden = !matching.slice(0, this.limit).includes(card); });
      const empty = this.querySelector('[data-review-empty]'); if (empty) empty.hidden = matching.length > 0;
      const more = this.querySelector('[data-review-more]'); if (more) more.hidden = matching.length <= this.limit;
      const status = this.querySelector('[data-review-status]');
      if (status) status.textContent = this.dataset.countTemplate.replace('[shown]', Math.min(matching.length, this.limit)).replace('[total]', matching.length);
    }
    showReview(card, opener) {
      const media = this.detail.querySelector('[data-detail-media]'), content = this.detail.querySelector('[data-detail-copy]');
      media.replaceChildren(card.querySelector('.review-photo').cloneNode(true));
      content.replaceChildren(card.querySelector('.review-content').cloneNode(true));
      // Block attributes are editor-only and must not be duplicated in the dialog.
      content.firstElementChild.className = 'review-detail-copy';
      content.querySelector('.review-author').id = this.detail.getAttribute('aria-labelledby');
      this.open(this.detail, opener);
    }
    validatePhoto() {
      const input = this.querySelector('[data-review-photo]'), file = input?.files?.[0];
      const error = this.querySelector('[data-review-error]');
      const invalid = file && (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024);
      const message = invalid ? this.dataset.photoError : '';
      input?.setCustomValidity(message);
      if (error) { error.textContent = message; error.hidden = !invalid; }
      return !invalid;
    }
    preview(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (!this.validatePhoto() || !form.reportValidity()) return;
      this.revokePhoto();
      const result = this.querySelector('[data-review-preview]');
      const data = new FormData(form), rating = Number(data.get('contact[Rating]'));
      result.querySelector('[data-preview-author]').textContent = data.get('contact[name]');
      const date = result.querySelector('[data-preview-date]'), now = new Date();
      if (date) { date.dateTime = now.toISOString(); date.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { dateStyle: 'medium' }).format(now); }
      result.querySelector('[data-preview-stars]').textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
      result.querySelector('[data-preview-text]').textContent = data.get('contact[body]');
      result.querySelector('[data-preview-product]').textContent = data.get('contact[Product]');
      const image = result.querySelector('img'), file = form.querySelector('[data-review-photo]')?.files?.[0];
      image.hidden = !file;
      if (file) { this.photoURL = URL.createObjectURL(file); image.src = this.photoURL; }
      else image.removeAttribute('src');
      result.hidden = false;
      result.focus();
    }
    clearPreview() {
      this.revokePhoto();
      const result = this.querySelector('[data-review-preview]');
      result.hidden = true; result.querySelector('img').removeAttribute('src');
      this.querySelector('[data-demo-review-form]').reset();
      this.querySelectorAll('[data-selected]').forEach(label => label.removeAttribute('data-selected'));
      this.validatePhoto();
      this.querySelector('.review-rating-options input')?.focus();
    }
    revokePhoto() { if (this.photoURL) URL.revokeObjectURL(this.photoURL); this.photoURL = null; }
    disconnectedCallback() { this.abort?.abort(); this.revokePhoto(); }
  }
  if (!customElements.get('photo-reviews')) customElements.define('photo-reviews', PhotoReviews);
})();
